var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.iosDialog
    }
  }, [_vm._v("更新苹果版本")])], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addDialog
    }
  }, [_vm._v("添加安卓版本")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "400px",
      prop: "downloadUrl",
      label: "下载链接"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "version",
      label: "版本"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "create",
      label: "更新时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "type",
      label: "版本类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.type == "1" ? _c("el-tag", [_vm._v("Wellce旧版")]) : _vm._e(), scope.row.type == "2" ? _c("el-tag", [_vm._v("Wellce国际版")]) : _vm._e(), scope.row.type == "3" ? _c("el-tag", [_vm._v("GooglePlay")]) : _vm._e(), scope.row.type == "100" ? _c("el-tag", [_vm._v("IOS")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "isMust",
      label: "强制更新"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.isMust === "false" || scope.row.isMust == false ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("否")]) : _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("是")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("修 改")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "600px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "110px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "安装包"
    }
  }, [_c("wlc-upload-file", {
    attrs: {
      url: _vm.form.downloadUrl
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "downloadUrl", $event);
      }
    }
  }), _vm.form.downloadUrl ? _c("p", [_c("a", {
    attrs: {
      href: _vm.form.downloadUrl,
      target: "_blank"
    }
  }, [_vm._v("下载链接")])]) : _vm._e()], 1), _c("el-form-item", {
    attrs: {
      label: "版本类型"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 2
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v("Wellcee国际版")]), _c("el-radio", {
    attrs: {
      label: 1
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v("Wellcee旧版")]), _c("el-radio", {
    attrs: {
      label: 3
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm._v("GooglePlay")])], 1), _c("el-form-item", {
    attrs: {
      label: "版本"
    }
  }, [_c("input", {
    attrs: {
      type: "file",
      id: "J_btn_upload",
      name: "img"
    },
    on: {
      change: _vm.fileSelect
    }
  }), _c("el-input", {
    attrs: {
      size: "small",
      placeholder: "选择apk包提取版本"
    },
    model: {
      value: _vm.form.version,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "version", $$v);
      },
      expression: "form.version"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "强制更新"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.isMust,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isMust", $$v);
      },
      expression: "form.isMust"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: false
    }
  }, [_vm._v("否")]), _c("el-radio-button", {
    attrs: {
      label: true
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "苹果版本编辑",
      width: "600px",
      visible: _vm.dialogIosVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogIosVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "110px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "版本号"
    }
  }, [_c("el-input", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.form.latestVersion,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "latestVersion", $$v);
      },
      expression: "form.latestVersion"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "强制更新版本号"
    }
  }, [_c("el-input", {
    attrs: {
      size: "small"
    },
    model: {
      value: _vm.form.version,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "version", $$v);
      },
      expression: "form.version"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogIosVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.saveIos
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };